import DceAjaxReplaceElementAction from "./ajax/DceAjaxReplaceElementAction";
import DceAjaxRemoveElementAction from "./ajax/DceAjaxRemoveElementAction";
import DceAjaxSetLocalStorageAction from "./ajax/DceAjaxSetLocalStorageAction";

import {DceAjax} from "dce-ajax";
DceAjax.getInstance().registerActionHandler('replace_element', new DceAjaxReplaceElementAction());
DceAjax.getInstance().registerActionHandler('remove_element', new DceAjaxRemoveElementAction());
DceAjax.getInstance().registerActionHandler('set_local_storage', new DceAjaxSetLocalStorageAction());

export {default as AlertButton} from "./components/AlertButton";
export {default as Preview} from "./components/Preview";
export {default as Toc} from "./components/Toc";
export {default as ScrollMenu} from "./components/ScrollMenu";
